.geoConfigSettings {
  display: grid;
  grid-template-columns: 392px 1fr;
  grid-template-rows: 64px 1fr;
  width: 100%;
  height: 100%;

  .geoConfigContent {
    grid-column: 1 /3;
    grid-row: 2;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
}
